









































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { uploadImage } from '@/api/images';

const STATUS_INITIAL = 0;
const STATUS_SAVING = 1;
const STATUS_SUCCESS = 2;
const STATUS_FAILED = 3;

@Component({})
export default class FileUploader extends Vue {
  uploadError = null;
  currentStatus: number = STATUS_INITIAL;

  get isInitial(): boolean {
    return this.currentStatus === STATUS_INITIAL;
  }

  get isSaving(): boolean {
    return this.currentStatus === STATUS_SAVING;
  }

  get isSuccess(): boolean {
    return this.currentStatus === STATUS_SUCCESS;
  }

  get isFailed(): boolean {
    return this.currentStatus === STATUS_FAILED;
  }

  reset(): void {
    this.currentStatus = STATUS_INITIAL;
    this.uploadError = null;
  }

  async processFile(event: Event) {
    const files = (<HTMLInputElement>event.target).files;

    if (files === null) {
      return;
    }

    try {
      this.currentStatus = STATUS_SAVING;
      const image = await uploadImage(files[0]);
      this.currentStatus = STATUS_SUCCESS;

      this.$emit('upload', image);
      this.reset();
    } catch (err) {
      this.uploadError = err.response.data.message;
      this.currentStatus = STATUS_FAILED;
    }
  }
}
